import { defineMessages } from 'react-intl';

import { PAYMENT_FREQUENCIES } from '@ratehub/documents/mtg-journey-document/stable';


export default defineMessages({
    [PAYMENT_FREQUENCIES.WEEKLY]: {
        id: 'Mortgages.paymentFrequencies.weekly',
        defaultMessage: 'Weekly',
    },
    [PAYMENT_FREQUENCIES.ACCELERATED_WEEKLY]: {
        id: 'Mortgages.paymentFrequencies.acceleratedWeekly',
        defaultMessage: 'Accelerated Weekly',
    },
    [PAYMENT_FREQUENCIES.BI_WEEKLY]: {
        id: 'Mortgages.paymentFrequencies.biweekly',
        defaultMessage: 'Bi-weekly',
    },
    [PAYMENT_FREQUENCIES.MONTHLY]: {
        id: 'Mortgages.paymentFrequencies.monthly',
        defaultMessage: 'Monthly',
    },
    [PAYMENT_FREQUENCIES.SEMI_MONTHLY]: {
        id: 'Mortgages.paymentFrequencies.semimonthly',
        defaultMessage: 'Semi-monthly',
    },
    [PAYMENT_FREQUENCIES.ACCELERATED_BI_WEEKLY]: {
        id: 'Mortgages.paymentFrequencies.acceleratedBiweekly',
        defaultMessage: 'Accelerated Bi-weekly',
    },
    [PAYMENT_FREQUENCIES.QUARTERLY]: {
        id: 'Mortgages.paymentFrequencies.quarterly',
        defaultMessage: 'Quarterly',
    },
    [PAYMENT_FREQUENCIES.ANNUALLY]: {
        id: 'Mortgages.paymentFrequencies.annually',
        defaultMessage: 'Annually',
    },
});
